import React from 'react';
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as rootActions } from '../actions'
import { NAME as MONITOR_NAME } from '../reducer'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';

import ResponsiveDrawer from "../../../components/ResponsiveDrawer"


function mapStateToProps(state) {
  return {
    ...state[MONITOR_NAME]
  }
}


const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...rootActions,
}, dispatch)


// Сколько последних складов показывать в боковом меню.
const SHOWN = 5

class SideMonitor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridItemStyle: {
        margin: '5px',
        padding: '5px',
        backgroundColor: 'lavender'
      },
      dateStyle: {
        color: 'cadetblue'
      }
    }
    props.getMonitorsList()
  }
  render() {
    // Последние изменённые склады сверху (дата обновляется при создании и при правке), не больше SHOWN.
    const latest = this.props.monitorsList
      .slice()
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .slice(0, SHOWN)
    return (
      <Grid container spacing={0}>
        {latest.map((monitorItem) => {
          const locDate = new Date(monitorItem.date).toLocaleDateString('ru-RU')
          return (
            <Grid component={Paper} key={'mg' + monitorItem.id} item xs={12} style={this.state.gridItemStyle} >
              {monitorItem.name} : {monitorItem.price} грн
              <br />
              <FormControl fullWidth>
                <Typography style={this.state.dateStyle} variant="caption" align={'right'} >{locDate}</Typography>
              </FormControl>
            </Grid>
          )
        })}
      </Grid>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SideMonitor)
